import { Textarea, type TextareaProps } from '@chakra-ui/react'
import { SizeType, InputVariant } from '@/types'
import React from 'react'


interface Props extends TextareaProps {
  variant?: InputVariant,
  size?: SizeType,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Textarea ref={ref} { ...props } />
  )
})


export {
  Component as Textarea,
  type Props as TextareaProps,
}
